/*@ngInject*/
const WatchManagerUtil = function ($rootScope, formViewerConstant) {

    this.viewport = [];
    this.elementList = null;

    function checkInView(viewportDom, elementDom) {
        let viewport = $(viewportDom),
            viewportOffsetTop = viewport.offset().top,
            viewportHeight = viewport.height(),
            element = $(elementDom),
            topOfElement = element.offset().top,
            bottomOfElement = topOfElement + element.height(),
            topOfViewport = viewportOffsetTop,
            bottomOfViewport = viewportOffsetTop + viewportHeight;

            return topOfElement < (bottomOfViewport+1) && bottomOfElement > topOfViewport;
        }

    this.clearWatcherList = function (scope) {
        let child = scope.$$childHead,
            childScopeWatcherList = [],
            watchers,
            clearWatchers = true;

        if (scope && scope.$$watchers && scope.$$watchers.length !== 0) {
            watchers = scope.$$watchers;
            _.each(watchers, function (watcher) {
                if (watcher.exp === 'uiWatchIsVisible') {
                    clearWatchers = false;
                }
            });

            if (clearWatchers) {
                scope.$$watchers = [];
            }
        }

        while (child) {
            childScopeWatcherList.push(this.clearWatcherList(child));
            child = child.$$nextSibling;
        }

        return function () {
            // Add back the watchers
            if (scope && watchers) {
                scope.$$watchers = _.union(scope.$$watchers, watchers);
            }

            // Add back the watchers for the children
            if (childScopeWatcherList.length !== 0) {
                angular.forEach(childScopeWatcherList, function (playChildWatcher) {
                    playChildWatcher();
                });
            }
        };
    };

    this.setupScope = function (viewport, elementList) {
        // Make sure we reset properly, since the elementList being passed into this method may have all or some of the entries run through the
        // setupScope method before, and we want to make sure their watchers are re-enabled before we lose the references to them.
        this.reset();

        this.viewport = viewport;
        this.elementList = elementList;

        this.elementList = _.map(elementList, function (fieldComponent) {
            return {
                dom: fieldComponent,
                scope: angular.element(fieldComponent).scope(),
                isActive: true,
                reActivateWatcherList: null
            };
        });
    };

    this.updateView = function () {
        _.each(this.elementList, function (fieldComponent) {
            let isInView = checkInView(this.viewport[0], fieldComponent.dom);

            if (!isInView && fieldComponent.isActive) {
                fieldComponent.reActivateWatcherList = this.clearWatcherList(fieldComponent.scope);
                fieldComponent.isActive = false;
                fieldComponent.scope.watchersDisabled = true;
                $(fieldComponent.dom).addClass('watchersDisabled');
            }

            if (isInView && !fieldComponent.isActive) {
                fieldComponent.isActive = true;
                fieldComponent.scope.watchersDisabled = false;
                $(fieldComponent.dom).removeClass('watchersDisabled');
                fieldComponent.reActivateWatcherList();
            }
        }.bind(this));

        $rootScope.$broadcast(formViewerConstant.event.FORM_RENDERING_OPTIMIZE_WATCHERS);
    };

    this.resetScope = function () {
        _.each(this.elementList, function (fieldComponent) {
            if (!fieldComponent.isActive) {
                if (fieldComponent.reActivateWatcherList) {
                    fieldComponent.reActivateWatcherList();
                }
            }
        });
    };

    this.resetScopeForFormId = function (formId) {
        _.each(this.elementList, function (fieldComponent) {
            if (!fieldComponent.isActive && fieldComponent.scope.fieldStructure.parentForm.id === formId) {
                if (fieldComponent.reActivateWatcherList) {
                    fieldComponent.reActivateWatcherList();
                }
            }
        });
    };

    this.resetScopeForComponentId = function (componentId) {
        _.each(this.elementList, function (fieldComponent) {
            if (!fieldComponent.isActive && fieldComponent.scope.fieldStructure.id === componentId) {
                if (fieldComponent.reActivateWatcherList) {
                    fieldComponent.reActivateWatcherList();
                }
            }
        });
    };

    this.reset = function () {
        this.resetScope();
        this.elementList = null;
        this.viewport = null;
    };

    this.resetByFormId = function (formId) {
        this.resetScopeForFormId(formId);
        this.elementList = _.filter(this.elementList, function (fieldComponent) {
            return fieldComponent.scope.fieldStructure.parentForm.id !== formId;
        });
    };
};

angular.module('umFormViewer').service('watchManagerUtil', WatchManagerUtil);
